exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lqUPy{padding:0 16px;padding:0 1rem}._7Nmaq{padding:0}", ""]);

// exports
exports.locals = {
	"padding": "lqUPy",
	"no_padding": "_7Nmaq"
};